export * from './action-types';

export const MAX_HS_RECORDS = 250;
export const WAITING_FOR_CLASSIFICATION = 'Waiting for Classification: Items queued for classification. If you believe these items have been unclassified for longer than 1 week, contact help@flow.io.';
export const CLASSIFIED = 'Classified: Item has been classified with a customs description, HS code, and global tariff codes.';
export const NON_CLASSIFIABLE = 'Non-classifiable - Not Enough Information: Please review…';
export const EXEMPT = 'Exempt: Items exempt from duties, such as digital gift cards.';
